<div ngbAccordion id="how-we-calculated" class="mb-4 mt-lg-5">
  <div ngbAccordionItem>
    <h2 ngbAccordionHeader>
      <button ngbAccordionButton [ngClass]="{ 'placeholder': !result }"><h6 class="align-middle mb-0">{{ 'si_pts_chrome_history_header' | cmsText | async }}</h6></button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template ngbPanelContent>

          <p [appParagraph]="2" [innerHtml]="'si_pts_chrome_history_intro' | cmsText | async"></p>

          <div class="row gx-5 p-2">
            @if (selfAssessmentFirst) {
            <ng-container *ngTemplateOutlet="gamtestBox"></ng-container>
            <ng-container *ngTemplateOutlet="gamblingDataBox"></ng-container>
            } @else {
            <ng-container *ngTemplateOutlet="gamblingDataBox"></ng-container>
            <ng-container *ngTemplateOutlet="gamtestBox"></ng-container>
            }
          </div>

          <ng-template #gamblingDataBox>
            <div class="col-12 col-md-6 p-2">
              <div class="bg-white rounded border border-light">
                <div class="p-3">
                  <p *ngIf="!!result?.analysis?.created_at" class="lead fs-6 mb-0 mt-2 text-uppercase">
                    {{ analysis_days | relativeDateCmsText:'si_pts_chrome_history_gambling_data_timestamp':result?.analysis?.created_at | async }}
                  </p>
                  <h4>{{ 'si_pts_chrome_history_gambling_data_header' | cmsText | async }}</h4>
                  <p [appParagraph]="2">{{ 'si_pts_chrome_history_gambling_data_intro' | cmsText | async }}</p>
                  @for (item of analysis; track item) {
                  <app-historyitem [historyitem]="item"></app-historyitem>
                  }
                  @empty {
                  <p>
                    <strong>{{ 'si_pts_chrome_history_gambling_data_empty' | cmsText | async }}</strong>
                  </p>
                  }
                </div>
              </div>
            </div>
          </ng-template>

          <ng-template #gamtestBox>
            <div class="col-12 col-md-6 p-2">
              <div class="bg-white rounded border border-light ">
                <div class="p-3">
                  <p *ngIf="!!result?.gamtest?.created_at" class="lead fs-6 mb-0 mt-2 text-uppercase">
                    <span>
                      {{ gamtest_days | relativeDateCmsText:'si_pts_chrome_history_gamtest_timestamp':result?.gamtest?.created_at | async }}
                    </span>
                    <span *ngIf="result?.gamtest?.outdated" class="badge bg-danger ms-2 text-uppercase">{{ 'si_pts_chrome_gamtest_outdated_test_badge_outdated' | cmsText | async }}</span>
                    <span *ngIf="!result?.gamtest?.['outdated']" class="badge bg-success ms-2 text-uppercase">{{ 'si_pts_chrome_gamtest_outdated_test_badge_valid' | cmsText | async }}</span>
                  </p>
                  <h4>{{ 'si_pts_chrome_history_gamtest_header' | cmsText | async }}</h4>
                  <p [appParagraph]="2">
                    {{ 'si_pts_chrome_history_gamtest_intro' | cmsText | async }}
                  </p>
                  @for (item of gamtest; track item) {
                  <app-historyitem [historyitem]="item"></app-historyitem>
                  }
                  @empty {
                  <p>
                    <strong>{{ 'si_pts_chrome_history_gamtest_empty' | cmsText | async }}</strong>
                  </p>
                  }
                </div>
              </div>
            </div>
          </ng-template>

        </ng-template>
      </div>
    </div>
  </div>
</div>
